import { render, staticRenderFns } from "./Blocker.vue?vue&type=template&id=70b11352&"
import script from "./Blocker.vue?vue&type=script&lang=js&"
export * from "./Blocker.vue?vue&type=script&lang=js&"
import style0 from "./Blocker.vue?vue&type=style&index=0&id=70b11352&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports